import { useCallback, useContext, useMemo } from "react";
import { tableHooks } from "components/Table";
import { LightButton } from "styles/GlobalStyle";
import { Add } from "@mui/icons-material";
import { isEmpty, map } from "lodash";
import { CreatePracticesContext, STEPS } from "../CreatePracticesContext";
import AvatarCell from "pages/School/TestTakers/AvatarCell"

const useTableColumns = () => {
    const testTakerNameCell = tableHooks.useTestTakerNameCell()
    const idCell = tableHooks.useIdCell()

    const { setSelectedTestTaker, setCurrentStep, setLearningUnitsAlert } = useContext(CreatePracticesContext)

    const goCreatePractices = useCallback((data) => {
        let testTaker = data
        if (testTaker.learning_units?.length > 1) {
            setSelectedTestTaker(testTaker)
            setLearningUnitsAlert({
                open: true,
                data: testTaker
            })
        }
        else {
            setSelectedTestTaker({ ...testTaker, learning_unit: testTaker.learning_units[0] })
            setCurrentStep(STEPS.SELECT_ASSESSMENTS)
        }
    }, [])

    const columns = useMemo(
        () => [
            {
                ...idCell,
                accessorKey: "test_taker_id"
            },
            {
                accessorKey: 'img',
                width: 30,
                header: "",
                cell: AvatarCell,
                meta: {
                    label: "פרופיל"
                }
            },
            testTakerNameCell,
            {
                accessorKey: 'school_class',
                header: "מקום לימודים",
                showBrokenDisplay: true
            },
            {
                accessorKey: "learning_units",
                header: "מסגרות נוספות",
                cell: ({ getValue }) => {
                    let learningUnits = getValue()
                    // מחזיר רק את יחידות הלמידה שהן לא כיתות בית ספריות
                    learningUnits = learningUnits.filter((lu) => isEmpty(lu.grade))
                    return map(learningUnits, o => o.display_name).join(', ')
                }
            },
            {
                accessorKey: 'create_practices',
                header: "",
                enableSorting: false,
                cell: ({ row }) => {
                    return (
                        <LightButton
                            action={() => goCreatePractices(row.original)}
                            size="small"
                            icon={<Add fontSize="small" color="dark" />}
                            label="התאמת תרגול"
                        />
                    );
                }
            },
        ], []
    )

    return columns
}


export default useTableColumns